import { render, staticRenderFns } from "./BannerAffiliator.vue?vue&type=template&id=23f1545b&"
import script from "./BannerAffiliator.vue?vue&type=script&lang=js&"
export * from "./BannerAffiliator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports